import React from 'react';
import { useField } from 'react-final-form';
import { styled } from '@linaria/react';

import { FieldMeta } from '@blocks/types';

import { ERROR_POLICY_EMPTY } from '../../constants';
import { Checkbox, Link } from '../../ui';
import { composeValidators } from '../../utils';
import { getEvaluatedGDPRlinks } from '../../utils/getGDPRlinks';
import { isError, required } from '../../utils/validators';
import { AuthProps } from '..';

const isRequired = required(ERROR_POLICY_EMPTY);

const GdprLabel = styled.label`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`;

const GdprTextAuth = styled.span<{ meta: FieldMeta }>`
  color: ${({ meta }) =>
    isError(meta) ? 'var(--bb-error-color)' : 'var(--bb-field-color)'} !important;

  &:hover {
    cursor: pointer;
  }

  & a {
    color: ${({ meta }) =>
      isError(meta) ? 'var(--bb-error-color)' : 'var(--bb-link-color)'} !important;
    text-decoration: ${({ meta }) => (isError(meta) ? 'underline' : 'none')};
  }

  & a:hover {
    text-decoration: ${({ meta }) => (isError(meta) ? 'none' : 'underline')};
  }
`;

export type GDPRAuthProps = Pick<
  AuthProps,
  'termsLink' | 'termsLabel' | 'policyLink' | 'policyLabel' | 'termLinkWriter' | 'policyLinkWriter'
>;

const Gdpr: React.FC<GDPRAuthProps> = props => {
  const { input: policyInput, meta: policyMeta } = useField('policy_agree', {
    validate: composeValidators(isRequired),
    type: 'checkbox',
  });

  const { input: marketingInput, meta: marketingMeta } = useField('marketing_agree', {
    type: 'checkbox',
  });
  const { input: userRole } = useField('user_role');

  const { policyLabel, policyLink, termsLabel, termsLink } = getEvaluatedGDPRlinks(props, userRole);
  return (
    <>
      <GdprLabel>
        <Checkbox
          {...policyInput}
          meta={policyMeta}
        />
        <GdprTextAuth meta={policyMeta}>
          I agree to the{' '}
          <Link
            href={termsLink}
            target="blank"
          >
            {termsLabel}
          </Link>{' '}
          and{' '}
          <Link
            href={policyLink}
            target="blank"
          >
            {policyLabel}
          </Link>
          .
        </GdprTextAuth>
      </GdprLabel>

      <GdprLabel>
        <Checkbox
          {...marketingInput}
          meta={marketingMeta}
        />
        <GdprTextAuth meta={marketingMeta}>
          I agree to receive bonuses, discounts and promotional materials.
        </GdprTextAuth>
      </GdprLabel>
    </>
  );
};

export default Gdpr;
